import * as actions from './updateContactActions';

const updateContactReducers = {
  [actions.USER_UPDATE_CONTACT_SEND_OTP_SUCCESS_RECEIVED]: (
    state,
    { payload }
  ) => {
    state.verifyContact = payload.verifyContact;
    return state;
  },
  [actions.USER_UPDATE_CONTACT_VERIFY_USER_NAME_SUCCESS_RECEIVED]: (
    state,
    { payload }
  ) => {
    state.userEmail = payload.newEmail;
    return state;
  },
  [actions.USER_UPDATE_CONTACT_VERIFY_CONTACT_SUCCESS_RECEIVED]: (
    state,
    { payload }
  ) => {
    // typeCode is returned as typeCode/typeCd as of now from backend. It needs to be made consistant at BE later.
    // channelCode is returned as channelCode/channelCd as of now from backend. It needs to be made consistant at BE later.
    const typeCode = payload.typeCode || payload.typeCd;
    const channelCode = payload.channelCode || payload.channelCd;
    if (!state.contacts) state.contacts = {};

    if (typeCode === 'WE')
      state.contacts = { ...state.contacts, workEmail: payload };

    if (typeCode === 'PM')
      state.contacts = {
        ...state.contacts,
        phone: { ...payload, ...{ typeCode }, ...{ channelCode } },
      };

    delete state.verifyContact;
    return { ...state };
  },
  [actions.USER_UPDATE_CONTACT_ADD_UPDATE_CONTACT_SUCCESS_RECEIVED]: (
    state,
    { payload }
  ) => {
    // typeCode is returned as typeCode/typeCd as of now from backend. It needs to be made consistant at BE later.
    // channelCode is returned as channelCode/channelCd as of now from backend. It needs to be made consistant at BE later.
    const typeCode = payload.typeCode || payload.typeCd;
    const channelCode = payload.channelCode || payload.channelCd;
    state.contacts = {
      ...state.contacts,
      phone: { ...payload, ...{ typeCode }, ...{ channelCode } },
    };
    return { ...state };
  },
  [actions.USER_RECAPTURE_WORK_EMAIL]: state => {
    delete state.verifyContact;
    return state;
  },
  [actions.USER_CLEAR_WORKEMAIL]: state => {
    if (state.contacts && state.contacts.workEmail)
      delete state.contacts.workEmail;
    return state;
  },
};

export default updateContactReducers;
